import { getConfig, configure } from './configuration';
import loggers from './loggers';
import { LEVELS, shouldLogLevel } from './levels';
const logFunctions = {};
const wrappedConfigure = (...args) => {
  configure(...args);
  loggers.forEach(logger => {
    if (getConfig(logger.key) && logger.check()) {
      logger.init();
    }
  });
};
LEVELS.forEach(level => {
  logFunctions[level] = (message, data) => {
    loggers.forEach(logger => {
      if (getConfig(logger.key) && logger.check() && shouldLogLevel(level)) {
        logger.handle(level, message, data);
      }
    });
  };
});
export default {
  configure: wrappedConfigure,
  ...logFunctions
};